<div class="h-100 container-map" [ngClass]="{'dialog-container': dialogParams && dialogParams.clickMap}">
  <i *ngIf="dialogParams && dialogParams.clickMap" matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions"
    (click)="dialogRef.close()"></i>
  <button id="confirmChangesMap" (click)="applyChanges()" type="button"></button>
  <div *ngIf="dialogParams && dialogParams.clickMap" class="autocomplete-address-container">
    <app-autocomplete-address [options]="{
      title: 'Dirección',
      initialValue: dataMap?.address ? dataMap?.address : null,
      showHintRequiredAddressSelection: true
    }" [inputFormControl]="addressControl">
    </app-autocomplete-address>
  </div>

  <google-map id="mapContainer" [center]="center" [zoom]="zoom" width="100%" height="100%"
    (mapClick)="onMapClick($event)">
    <map-marker *ngFor="let marker of markers" #markerRef
      [position]="{lat: marker.lat, lng: marker.lng}" [icon]="marker.iconUrl"
      (mapClick)="openInfoWindow(markerRef, marker)">
    </map-marker>
    <map-info-window #infoWindow>
      <div *ngIf="activeMarkerData?.anomaly">
        <b>{{activeMarkerData?.anomaly}}</b>
      </div>
      <div *ngIf="activeMarkerData?.date">
        <b>Fecha:</b> {{activeMarkerData?.date | dateFormat}}
      </div>
      <div *ngIf="activeMarkerData?.fingerprint">
        <b>Usuario:</b> {{activeMarkerData?.fingerprint.userName}}
      </div>
      <div *ngIf="!utils.isEmpty(activeMarkerData?.formWeb)">
        <b>{{activeMarkerData?.formWeb ? 'Registro por Web' : 'Registro por Conductor'}}</b>
      </div>
    </map-info-window>
    <map-polyline *ngFor="let polyline of polylines" [path]="getPolylinePath(polyline)"
      [options]="{strokeColor: polyline.strokeColor}">
    </map-polyline>
  </google-map>
  <div class="col-md-12 text-center">
    <mat-card-actions *ngIf="dialogParams && dialogParams.clickMap">
      <button mat-raised-button color="primary" type="button" class="button-width-auto" (click)="sendDataMapa()">
        Guardar
      </button>
    </mat-card-actions>
  </div>

</div>